export default __webpack_public_path__ + "static/media/confirm.fe7894ea.png";